
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"color",attrs:{"fill":"#A3A3A3","d":"M22.25 12.567a.5.5 0 010 .866l-21 12.124a.5.5 0 01-.75-.433V.876a.5.5 0 01.75-.433l21 12.124z"}})])
          )
        }
      }
    